var _style, _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 350",
    style: {
      enableBackground: "new 0 0 350 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#84C779;}\r\n\t.st1{display:none;}\r\n\t.st2{display:inline;fill:#84C779;}\r\n\t.st3{display:none;fill:none;stroke:#ED2024;stroke-miterlimit:10;}\r\n\t.st4{display:inline;fill:#5D5D5D;}\r\n\t.st5{display:none;fill:#ED2025;}\r\n\t.st6{opacity:0.35;}\r\n\t.st7{fill:#ED2025;}\r\n\t.st8{display:inline;fill:none;stroke:#ED2025;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-36.8-131.8c-32.4,21.6-40.6,66.1-18.4,99.5C-33,1,11.3,10.5,43.7-11c32.4-21.6,40.7-66.1,18.4-99.5 C39.9-143.9-4.4-153.4-36.8-131.8L-36.8-131.8z M34.7-24.5C9.5-7.8-24.8-15.2-42.1-41.1c-0.2-0.3-0.4-0.6-0.6-0.9l20.5-6.8L18-62 l0-18.5l-67.8,22.3c-6.2-23.1,2.7-47.3,22.1-60.2c25.2-16.7,59.6-9.3,76.8,16.6C66.3-75.9,59.9-41.3,34.7-24.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-36.8-131.8c-32.4,21.6-40.6,66.1-18.4,99.5C-33,1,11.3,10.5,43.7-11c32.4-21.6,40.7-66.1,18.4-99.5 C39.9-143.9-4.4-153.4-36.8-131.8L-36.8-131.8z M34.7-24.5C9.5-7.8-24.8-15.2-42.1-41.1c-0.2-0.3-0.4-0.6-0.6-0.9l20.5-6.8L18-62 l0-18.5l-67.8,22.3c-6.2-23.1,2.7-47.3,22.1-60.2c25.2-16.7,59.6-9.3,76.8,16.6C66.3-75.9,59.9-41.3,34.7-24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-17-29.1L18-40.8v-18.6l-36,12.1L-17-29.1L-17-29.1L-17-29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-20.1-70.4L18-83.1v-18.6l-39.1,13.1L-20.1-70.4L-20.1-70.4z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 169.9,
    y1: -72.2,
    x2: 197.9,
    y2: -72.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.5,
    y: 92.4,
    className: "st4",
    width: 17.5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.2,
    y: 92.4,
    className: "st4",
    width: 17.5,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.6,
    y: 128,
    className: "st4",
    width: 4,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.6,
    y: 43.2,
    className: "st4",
    width: 4,
    height: 17.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2959.8,1265.5c-15.3,244.2-218.2,437.5-466.2,437.5c-157.8,0-297.2-78.2-381.8-197.9 c93.7,131.6,253.1,210.8,424.8,194.5c104.9-10,196.6-51.1,274.3-122.4c33.2-30.5,61.2-65.3,83.7-104.7c-2.2-0.1-3.9,0.2-5.7,0.7 c-48.6,13-97.1,26-145.7,39.1c-53.3,14.3-106.6,28.9-160,43c-3.4,0.9-6.9,1.8-10.3,2.7c-42.4,11.1-85.6,12.7-128.9,6.3 c-45.4-6.7-87.7-22.3-126.7-46.5c-8.9-5.5-17.3-11.6-26.8-18c2.1-0.8,2.9-1.2,3.8-1.5c11.1-3,22.2-5.9,33.3-8.9 c69.8-18.7,139.6-37.4,209.4-56.1c86.7-23.2,173.4-46.5,260-69.8c50.2-13.5,100.3-27.1,150.5-40.5c3.9-1,5.8-2.7,6.3-6.9 C2955.6,1299.1,2958.4,1282.3,2959.8,1265.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M175,0C78.3,0,0,78.4,0,175c0,96.6,78.3,175,175,175s175-78.4,175-175S271.6,0,175,0z M175,312.8 c-76.1,0-137.8-61.7-137.8-137.8C37.2,98.9,98.9,37.2,175,37.2c26.9,0,52,7.7,73.2,21L215,67.1l-67.5,18.1l-7.3,1.9l0,0 c-27,8.4-48.7,28.7-59.1,54.7L226.2,103l6.7-1.8c0,0,0,0,0.1,0.1l28.9-7.8c0,0,0,0,0-0.1l20-5.4c19.3,23.7,30.9,54,30.9,87 c0,7.4-0.6,14.7-1.7,21.7l-26.8,7.2l-28.9,7.8l-145.1,38.9c16,12.5,36.1,20,58,20c7.3,0,14.4-0.8,21.2-2.4l6.3-1.7l8.2-2.2 c-0.5,0.2-0.9,0.3-1.4,0.4l67.8-18.2c0,0,0-0.1,0.1-0.1l26.5-7.1C273.7,283.1,227.8,312.8,175,312.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.9,171.1l13.6-3.6c-0.8-13-4.2-25.2-9.7-36.2L88.2,178.8c0,0,0,0,0,0l-13.6,3.6c0.8,13,4.2,25.2,9.7,36.2 L261.9,171.1C261.9,171.1,261.9,171.1,261.9,171.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: -677.6,
    y1: 2949.8,
    x2: -820,
    y2: 2949.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 232.2,
    y1: 2949.8,
    x2: 89.8,
    y2: 2949.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRound);
export default __webpack_public_path__ + "static/media/logoRound.1f576122dce8439a645968de4871be5f.svg";
export { ForwardRef as ReactComponent };